import store from "@/store";
import requestService from "@/service/requestService";

export class PromiseService {
  reqService: requestService;

  constructor() {
    this.reqService = new requestService();
  }

  getFunctionSettingPM() {
    let promise = new Promise((resolve, reject) => {
    this.reqService.getFunctionSettingPM().then(
        (response: any) => {
          if (response) {
	    store.dispatch("FunctionSetting/setState", response);
	  }
          resolve();
        },
        (err: any) => { reject(); }
      )
    });
    return promise;
  }
}